module.exports = __webpack_public_path__ + "static/media/positive_event_response.e84413a6.png";